import { useEffect } from "react";

// Quantos formulários desta aba estão com alteração não salva.
// Lido pelo mecanismo de atualização: com trabalho aberto, a aba não é
// recarregada sozinha; mostra o aviso de nova versão.
let unsavedCount = 0;

export function hasUnsavedWork(): boolean {
  return unsavedCount > 0;
}

export function useBeforeUnload(shouldWarn: boolean, message?: string) {
  useEffect(() => {
    if (!shouldWarn) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message || "Você tem alterações não salvas.";
    };

    unsavedCount++;
    window.addEventListener("beforeunload", handler);
    return () => {
      unsavedCount--;
      window.removeEventListener("beforeunload", handler);
    };
  }, [shouldWarn, message]);
}
